/**
 * @GENERATED from Figma node 3638:51945
 */

import * as React from "react";
export type IconProps = Omit<React.SVGProps<SVGSVGElement>, "color">;
const ImageBright = (props: IconProps, ref: React.Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    focusable={false}
    role="presentation"
    ref={ref}
    {...props}
  >
    <path
      fill="#7F776F"
      fillRule="evenodd"
      d="M2 2h20v11.353l-.374-.374-.075-.075c-.621-.623-1.288-1.287-1.943-1.82a4.6 4.6 0 0 0-1.334-.874 3.3 3.3 0 0 0-.983-.301 4.64 4.64 0 0 0-4.139 1.277l-3.098 3.1a1.097 1.097 0 0 1-1.514 0L8 13.743a3.21 3.21 0 0 0-2.833-.88 2.3 2.3 0 0 0-.682.205q-.175.073-.34.168v.016a5 5 0 0 0-.452.32c-.438.346-.872.79-1.246 1.181l-.208.219-.239.25zm7.984 9.17c-.27.1-.56.139-.847.116a1.986 1.986 0 0 1-2.14-2.143A1.99 1.99 0 0 1 9.136 7a1.986 1.986 0 0 1 2.142 2.143 1.99 1.99 0 0 1-1.295 2.027"
      clipRule="evenodd"
    />
    <path
      fill="#7F776F"
      d="M20.14 14.523c.594.596 1.231 1.235 1.86 1.767V22H2v-4.017c.1-.045.187-.094.258-.137.223-.137.433-.31.617-.477.303-.273.633-.621.939-.943l.329-.345v.01l.589-.59q.15-.137.29-.25c.234-.183.36-.238.396-.254l.01-.005a1.07 1.07 0 0 1 1.055.272l.541.542a3.21 3.21 0 0 0 4.542 0l3.1-3.103a2.51 2.51 0 0 1 2.75-.527l.011.005c.19.098.428.25.72.48l.05.039.03.03 1.617 1.5v-.003z"
    />
  </svg>
);
const ForwardRef = React.forwardRef(ImageBright);
export { ForwardRef as ImageBright };
